import React, { useEffect, useState } from "react";
import StepCard from "../../stories/Cards/StepCard";
import step1 from "../../assets/images/shakey-icon.svg";
import step2 from "../../assets/images/gold-tube.svg";
import step3 from "../../assets/images/healthcare-step-3.svg";
import step2_2 from "../../assets/images/gold_lav_tube.svg";
import step3_2 from "../../assets/images/tubes-in-bag.svg";
import step4 from "../../assets/images/box-1.svg";
import step4_2 from "../../assets/images/box.svg";
import step5 from "../../assets/images/tube-in-bag.svg";
import step6 from "../../assets/images/thermometer.svg";
import { Button } from "../../stories/Buttons/Button";
import { useAuth } from "../../components/AuthContext/AuthContext";
import { useParams, useNavigate, useLocation } from "react-router";
import useApis from "../../services/useAPI";
import SuccessModal from "../../stories/Modals/Modal";
import logo from "../../assets/images/boots-myhealthchecked-logo.svg";
import img from "../../assets/images/notification.svg";
import { links } from "../../stories/Forms/fields";
import LoggedInLayout from "../../stories/LoggedInScreens/LoggedInLayout";
import CheckList from "./CheckList";
import { checklistIcons, twoChecklistIcons } from "../../assets/images/checklist";
import { stepsOne, stepsTwo } from "../../utils/constants";
import { XCircleFill } from "react-bootstrap-icons";

// Declare steps variable to be assigned later
let steps;

const ConfirmationSteps = () => {
  const location = useLocation();
  const testType = location?.state?.testType;
  // Extract secondary barcode from location state
  const { secondary_barcode } = location.state || {};

  const [selectedSteps, setSelectedSteps] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  let selectedService = localStorage.getItem("selectedService");
  // Extract id from URL parameters
  const { id } = useParams();
  const navigate = useNavigate();

  // Define steps with conditional images based on the presence of secondary_barcode
  steps = [
    {
      number: 1,
      image: step1,
      body: (secondary_barcode && stepsTwo.Box1) || stepsOne.Box1,
    },
    {
      number: 2,
      image: (secondary_barcode && step2_2) || step2,
      body: (secondary_barcode && stepsTwo.Box2) || stepsOne.Box2,
    },
    {
      number: 3,
      image: (secondary_barcode && step3_2) || step3,
      body: (secondary_barcode && stepsTwo.Box3) || stepsOne.Box3,
    },
    {
      number: 4,
      image: (secondary_barcode && step4_2) || step4,
      body: (secondary_barcode && stepsTwo.Box4) || stepsOne.Box4,
    },
    {
      number: 5,
      image: step5,
      body: (secondary_barcode && stepsTwo.Box5) || stepsOne.Box5,
    },
    {
      number: 6,
      image: step6,
      body: (secondary_barcode && stepsTwo.Box6) || stepsOne.Box6,
    },
  ];

  const postUrl = `/api/phlebotomists-portal/register-appointment/${id}/`;
  const {
    callApi,
    resultPost,
    message,
    modalShow,
    tokenError,
    toggleShowError,
    setModalShow,
    serverError,
  } = useApis();

  useEffect(() => {
    if (serverError || tokenError) {
      auth?.showToast(
        "Error",
        tokenError || serverError,
        "../assets/mhc.png",
        {icon: <XCircleFill />,
          className: auth?.featureFlag && "vh-toaster"
        },
      );
    }
  }, [serverError, tokenError]);

  const auth = useAuth();
  const stages = ["patient-details","enter-barcode","appointment-confirmation"];
  
  useEffect(() => {
    callApi(null, postUrl, "GET", {
      Authorization: `Bearer ${
        localStorage.getItem("access_token") || auth.accessToken
      }`,
      "Content-Type": "application/json",
    });

    if (!stages.includes(sessionStorage.getItem("allowedStage")) && auth?.featureFlag) {
      navigate("/patient-record");
    }
  },[sessionStorage.getItem("allowedStage"), auth?.featureFlag, navigate]);

  // Set the title when the component mounts or when certain dependencies change
  useEffect(() => {
    auth.setTitle("CONFIRMATION OF TEST REGISTRATION");
    if (selectedService === "healthCare") {
      auth.setTitle(`In-store Wellness Testing Service - ${testType}`);
    }
  }, [auth, message, navigate, resultPost]);

  // Handle step card click to toggle selection
  const handleCardClick = (number) => {
    setSelectedSteps((prevSelectedSteps) =>
      prevSelectedSteps.includes(number)
        ? prevSelectedSteps.filter((step) => step !== number)
        : [...prevSelectedSteps, number],
    );
    setErrorMessage("");
  };

  // Handle confirm button click to validate step completion and make API call
  const handleConfirm = () => {
    const allStepsSelected = selectedSteps.length === steps.length;

    if (allStepsSelected) {
      if (auth?.featureFlag) {
        auth?.allowStage("appointment-confirmation");
        navigate(`/appointment-confirmation/${id}`, {
          state: { study: location.state?.study },
          replace: true,
        });
        return;
      }
      
      callApi(null, postUrl, "POST", {
        Authorization: `Bearer ${
          localStorage.getItem("access_token") || auth.accessToken
        }`,
        "Content-Type": "application/json",
      });
      localStorage.removeItem("secondary_barcode");
      return;
    }

    setErrorMessage("Please ensure all steps are completed before proceeding");
  };

  const handleRedirect = () => {
    navigate("/patient-record");
  };

  const successModal = modalShow && (
    <SuccessModal
      handleClose={""}
      href={"/patient-record"}
      label={"Return to home"}
      message={"Service completed successfully"}
      onHide={() => {
        setModalShow(false);
        setTimeout(() => {
          navigate("/patient-record");
        }, 500);
      }}
      heading="Success"
      redirect={handleRedirect}
      show={modalShow}
      variant={"secondary"}
      close={false}
    />
  );

  if (auth?.featureFlag) {
    return (
      <CheckList
        icons={secondary_barcode ? twoChecklistIcons : checklistIcons}
        cardTitle={`For ${secondary_barcode ? "two" : "one"} tube test:`}
        onContinue={handleConfirm}
        onToggle={handleCardClick}
        selectedSteps={selectedSteps}
        steps={steps}
      >
        {successModal}
      </CheckList>
    );
  }

  return (
    <LoggedInLayout
      buttonLabel={"Logout"}
      img={img}
      isActivation={false}
      links={links}
      logo={logo}
      pageTitle={auth.title}
      userInitials={auth.userInitials}
    >
      <div className="test-confirmation-page">
        <div className="container p-0">
          <div className="row">
            <div className="col-md-12">
              <h2>Prepare the sample for storage and collection</h2>
              <p>
                Click each checklist card in order to acknowledge all items.
                Once each card is checked and acknowledged, the <b>Confirm</b> button
                will appear. Click it to submit your registration.
              </p>
            </div>
          </div>
        </div>
        <div className="confirm-card card">
          <h2>For {secondary_barcode ? "two" : "one"} tube test:</h2>
          <p>
            Before returning the sample,
            <u> please click to confirm the following steps:</u>
          </p>
          <div className="container p-0">
            <div className="row">
              {steps?.map((step) => (
                <StepCard
                  body={step.body}
                  image={step.image}
                  isSelected={selectedSteps.includes(step.number)}
                  key={step.number}
                  number={step.number}
                  onClick={() => handleCardClick(step.number)}
                />
              ))}
              {errorMessage && (
                <div className="server-error">{errorMessage}</div>
              )}
            </div>
          </div>
        </div>
        {selectedSteps?.length === steps?.length && (
          <Button
            className="mt-4 mr-4 float-end btn btn-primary"
            label={"Confirm"}
            onClick={handleConfirm}
            size={"small"}
          />
        )}
      </div>
      {successModal}
    </LoggedInLayout>
  );
};

export default ConfirmationSteps;